import TotalRevenueSalesModule from "./totalRevenueSalesModule";
import TotalRevenueSalesSaga from "./redux/totalRevenueSalesSagas";
import TotalRevenueSalesReducer from "./redux/totalRevenueSalesReducer";

export default {
  Component: TotalRevenueSalesModule,
  moduleName: "totalRevenueSales",
  saga: TotalRevenueSalesSaga(),
  reducer: TotalRevenueSalesReducer
};
